import * as React from 'react';

import classnames from 'classnames';

import {StatusBadge} from 'shells/status-badge/status-badge';

import type {GetContactAudienceMemberships_contact as Contact} from 'nutshell-graphql-types';

import {PreferenceCenterLinkCopy} from './preference-center-link-copy';

import styles from './audience-info.module.css';

type Props = {
    contact: Contact;
    isSupportLogin: boolean;
};

export function UnsubscribedFromAllAudiences(props: Props) {
    return (
        <>
            <div className={styles['audience-info-outer-container']}>
                <div className={styles['audience-info-inner-container']}>
                    <StatusBadge
                        level='warning'
                        text='Unsubscribed'
                        detail={
                            props.contact.name
                                ? `${props.contact.name} has opted out of all marketing communications`
                                : undefined
                        }
                    />
                </div>
            </div>
            <div className={styles['unsubscribed-pill-label']}>
                <i>
                    This person has unsubscribed from all of your outreach and cannot be added to
                    any audiences.{' '}
                </i>
                {props.isSupportLogin ? (
                    <div>
                        <br />
                        <b>Support only:</b>
                        <br />
                        Unsubscribed via {props.contact.unsubscribedFromAllAudiencesSource}
                        <a
                            href='#'
                            onClick={() => {
                                resubscribeContact(props.contact.id);
                            }}
                            className={classnames(
                                'ui-link-standard',
                                styles['support-resubscribe-link']
                            )}
                        >
                            Resubscribe this person
                        </a>
                    </div>
                ) : undefined}
            </div>
            {props.contact.preferenceCenterLink ? (
                <PreferenceCenterLinkCopy link={props.contact.preferenceCenterLink} />
            ) : undefined}
        </>
    );
}

// @ts-expect-error
function resubscribeContact(id) {
    Nut.ajax.post({
        url: '/support/resubscribe-contact.json',
        data: {contactId: id},
    });
    location.reload();
}
